import {
  ServiceListItemDto,
  ServiceReadDto,
  ServiceStatsDto,
} from '../models/service-management-api';

export interface ServiceManagementState {
  rows: ServiceListItemDto[];
  totalServices: number;
  activeServices: number;
  inactiveServices: number;
  loadingList: boolean;
  loadingDetail: boolean;
  submitting: boolean;
  exporting: boolean;
  statusUpdatingId: string | null;
  slaUpdatingId: string | null;
  error: string | null;
  successMessage: string | null;
  selectedService: ServiceReadDto | null;
  selectedServiceId: string | null;
  selectedMode: 'view' | 'edit' | null;
  currentPage: number;
  pageSize: number;
}

export const initialServiceStats: ServiceStatsDto = {
  allServices: 0,
  activeServices: 0,
  inactiveServices: 0,
};

export const initialServiceManagementState: ServiceManagementState = {
  rows: [],
  totalServices: initialServiceStats.allServices,
  activeServices: initialServiceStats.activeServices,
  inactiveServices: initialServiceStats.inactiveServices,
  loadingList: false,
  loadingDetail: false,
  submitting: false,
  exporting: false,
  statusUpdatingId: null,
  slaUpdatingId: null,
  error: null,
  successMessage: null,
  selectedService: null,
  selectedServiceId: null,
  selectedMode: null,
  currentPage: 1,
  pageSize: 10,
};
